/**
 * Main app
 *
 */

"use strict";

import { AmericorForm } from "./form.js";

class App {
  constructor() {
    this.init_custom_events();

    const americor_form = new AmericorForm();
  }

  /**
   * Fire datalayers for custom form events
   * 
   */
  init_custom_events()
  {
    window.dataLayer = window.dataLayer || [];

    document.addEventListener('form:afterSubmit', (e) => {
      console.log(e);

      if ( e && e.detail.form_details && e.detail.response )
      {
        const form_details = e.detail.form_details;
        const response     = e.detail.response;
        
        // Step 1 - Mailer Code
        if ( form_details.leadAction == 'offer_code' )
        {
          window.dataLayer.push({
            event: "mailer_code",
            lead_id: response.uuid,
          });
        }

        // Step 2 - Debt Amount
        if ( form_details.leadAction == 'create_lead' ||
             ( form_details.leadAction == 'update_lead' && ! form_details.isCompleted ) )
        {
          window.dataLayer.push({
            event: "leadInfo",
            lead_id: response.uuid,
          });
        }

        if ( form_details.isCompleted )
        {
          window.dataLayer.push({
            event: "leadGenerated",
            lead_id: response.uuid,
            firstName: response.firstName,
            lastName: response.lastName,
            phoneNumber: response.phone,
            leadStatus: response.quality,
            email: response.email,
            city: response.city,
            zip: response.zip,
            debt_amount: response.debt,
            credit_pull: ( (response.debtCreditReport) ? parseFloat(response.debtCreditReport) : 0.00 )
          });
        }
      }
    });
  }
}

const app = new App();
